import React, { PropsWithChildren } from 'react'
import { getClassNames } from '../../../_utils/classnames'
import { Flex } from 'antd'

type BuilderAside = {
    className?: string
    ref?: any
}

export const AppMessageBuilderAside: React.FC<PropsWithChildren<BuilderAside>> = (props) => {
    const { className, ref, children } = props

    return (
        <div style={{ position: 'sticky', top: 0 }} className={getClassNames('app-message-builder-aside-wrapper')}>
            <Flex
                justify="flex-start"
                flex={'0 0 440px'}
                gap={16}
                className={getClassNames('app-message-builder-aside', className)}
                ref={ref}
                vertical
            >
                {children}
            </Flex>
        </div>
    )
}
